<template>
  <StyleQuizLayout
    :title="$t('project_details.style_quiz.select_ornaments_you_like')"
    :subtitle="$t('project_details.style_quiz.select_ornaments')"
    :loading="loading"
    :data="options"
    @onBack="emit('onBack')"
    @onNext="onSubmit"
    :multiple="false"
    :percent="55"
    :initialSelected="quizStore.stage2.map((i) => i.id)"
  />
</template>

<script setup>
import ApiHelper from "@/helpsers/api.helper";
import authHelper from "@/helpsers/auth.helper";
import axios from "axios";
import { inject, onMounted, ref } from "vue";
import AlertHelper from "@/helpsers/alert.helper";
import StyleQuizLayout from "../StyleQuizLayout.vue";
import { useQuizStore } from "@/stores/quiz.store";

const alert = inject("alert");
const emit = defineEmits(["onBack", "onDone"]);
const options = ref(null);

const loading = ref(true);
const quizStore = useQuizStore();

onMounted(() => {
  const tags = quizStore.stage1.map((i) => i.tags).join(",");
  axios
    .get(ApiHelper.getStyleQuizPhotosUrl() + "?stage=2" + "&tags=" + tags, {
      headers: authHelper.authHeader(),
    })
    .then((res) => (options.value = res.data))
    .catch((e) => {
      AlertHelper.show(
        alert,
        "Błąd wczytywania strony",
        e.response?.data?.message,
        "error"
      );
    })
    .finally(() => (loading.value = false));
});
function onSubmit(results) {
  quizStore.stage2 = results;
  emit("onDone");
}
</script>

<style scoped lang="scss"></style>
